module.exports = __webpack_public_path__ + "img/160.b5640071.jpg";